import { render, staticRenderFns } from "./yikaipiaoCB.vue?vue&type=template&id=ee30ca70&scoped=true&"
import script from "./yikaipiaoCB.vue?vue&type=script&lang=js&"
export * from "./yikaipiaoCB.vue?vue&type=script&lang=js&"
import style0 from "./yikaipiaoCB.vue?vue&type=style&index=0&id=ee30ca70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee30ca70",
  null
  
)

export default component.exports